export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Solicitação para suporte técnico"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["de"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Chat"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Adicionar mensagem"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Arquivos"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Você pode carregar um ou mais arquivos. Tamanho máximo do arquivo - 10MB."])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Texto da mensagem"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Enviar"])}
}